module.exports = __webpack_public_path__ + "img/英文-广告.4b721cc2.jpg";